import { render, staticRenderFns } from "./BatchHistory.vue?vue&type=template&id=3ab1be60&"
import script from "./BatchHistory.vue?vue&type=script&lang=js&"
export * from "./BatchHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports